exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".created[data-v-4af06578]{color:#a7afba}.story[data-v-4af06578]{border-radius:8px;border:1px solid #e5e5e5;margin-top:20px;padding:10px;font-size:14px;position:relative}.story[data-v-4af06578]:after,.story[data-v-4af06578]:before{content:\"\";position:absolute;left:20px;bottom:-10px;border-color:#e5e5e5 transparent transparent #e5e5e5;border-width:5px;border-left:5px solid transparent;border-top:5px transparent;border-style:solid}.story[data-v-4af06578]:after{left:21px;border-color:#fff transparent transparent #fff;border-width:5px 5px 5px 3px}", ""]);

// exports
